<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 报表管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>仓库发货端报表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="运单号" prop="freightBillCode">
                <el-input v-model.trim="searchform.freightBillCode" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="发运单号" prop="outBillCode">
                <el-input v-model.trim="searchform.outBillCode" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="仓库编码" prop="fromWarehouseCode">
                <el-input v-model.trim="searchform.fromWarehouseCode" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="客户名称" prop="dealerName">
                <el-input v-model.trim="searchform.dealerName" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="客户编码" prop="dealerCode">
                <el-input v-model.trim="searchform.dealerCode" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="批次号" prop="batchno">
                <el-input v-model.trim="searchform.batchno" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品代码" prop="productCode">
                <el-input v-model.trim="searchform.productCode" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="发货日期" prop="outtimelist">
                <el-date-picker
  
                  style="width:100%"
                  v-model="searchform.outtimelist"
                  type="daterange"
                  value-format="timestamp"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="search"
                v-permission="['shipments_select']"
              >搜索</el-button>
              <el-button
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
                v-permission="['shipments_export']"
              >导出Excel</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>仓库发货端报表</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
            <el-table-column
              prop="freightBillCode"
              label="运单号"
              min-width="100"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="outBillCode" label="发运单号" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dealerCode" label="客户编码" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dealerName" label="客户名称" min-width="220" show-overflow-tooltip></el-table-column>
            <el-table-column prop="address" label="客户地址" min-width="300" show-overflow-tooltip></el-table-column>
            <el-table-column
              prop="fromWarehouseCode"
              label="发货仓库编码"
              min-width="100"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="fromWarehouse"
              label="发货仓库"
              min-width="160"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="outBillTime" label="发货日期" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode" label="条码" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="orderno" label="订单" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="batchno" label="批次号" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="factoryName" label="工厂" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="workgroupName" label="班组" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="worklineName" label="产线" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="produceTime" label="生产时间" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="productCode" label="产品编码" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="productName" label="产品名称" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column
              prop="specs"
              label="箱规"
              min-width="140"
              show-overflow-tooltip
              fixed="right"
            ></el-table-column>
            <el-table-column
              prop="qualityPeriod"
              label="有效期（天）"
              min-width="140"
              show-overflow-tooltip
              fixed="right"
            ></el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { orderandworkproducts } from "@/api/report";
//引入导出组件模块
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.open()
  },
  data() {
    return {
      //基础数据
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //搜索表单数据
      qrcode_status: [
        {
          value: 3,
          label: "已下载"
        },
        {
          value: 4,
          label: "未下载"
        }
      ],
      searchform: {
        outtimelist: null,
        sproduceTime: null,
        eproduceTime: null,
        soutBillTime: null,
        eoutBillTime: null,
        dealerName: null,
        dealerCode: null,
        freightBillCode: null,
        outBillCode: null,
        fromWarehouseCode: null,
        batchno: null,
        productCode: null,
        currPage: 1,
        pageSize: 10
      }
    };
  },
  methods: {
    //请求表格数据
    Tabledata(obj) {
      if (
        this.searchform.outtimelist ||
        this.searchform.dealerName ||
        this.searchform.dealerCode ||
        this.searchform.freightBillCode ||
        this.searchform.outBillCode ||
        this.searchform.fromWarehouseCode ||
        this.searchform.batchno ||
        this.searchform.productCode
      ) {
        this.listLoading = true;
        orderandworkproducts(obj).then(response => {
          this.tableData = response.data.list;
          this.packdate(this.tableData);
          this.total_count = response.data.totalCount;
          this.currentPage = response.data.page;
          this.listLoading = false;
          console.log(this.tableData);
        });
      } else {
        this.$message({
          type: "warning",
          message: "请输入搜索条件"
        });
      }
    },
    // 拼数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        obj[i].outBillTime = this.$parseTime(obj[i].outBillTime);
        obj[i].produceTime = this.$parseTime(obj[i].produceTime);
        //  obj[i].fromWarehouse = (obj[i].fromWarehouseCode|| " ") + (obj[i].fromWarehouse|| " ")
      }
    },
    //搜索事件
    search() {
      this.Tabledata({
        soutBillTime: this.searchform.outtimelist==null ? null:this.searchform.outtimelist[0],
        eoutBillTime: this.searchform.outtimelist==null ? null:this.searchform.outtimelist[1],
        dealerName: this.searchform.dealerName,
        dealerCode: this.searchform.dealerCode,
        freightBillCode: this.searchform.freightBillCode,
        outBillCode: this.searchform.outBillCode,
        fromWarehouseCode: this.searchform.fromWarehouseCode,
        batchno: this.searchform.batchno,
        productCode: this.searchform.productCode,
        pageSize: this.searchform.pageSize
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.currPage = currPage;
      this.Tabledata({
        soutBillTime: this.searchform.outtimelist==null ? null:this.searchform.outtimelist[0],
        eoutBillTime: this.searchform.outtimelist==null ? null:this.searchform.outtimelist[1],
        dealerName: this.searchform.dealerName,
        dealerCode: this.searchform.dealerCode,
        freightBillCode: this.searchform.freightBillCode,
        outBillCode: this.searchform.outBillCode,
        fromWarehouseCode: this.searchform.fromWarehouseCode,
        batchno: this.searchform.batchno,
        productCode: this.searchform.productCode,
        pageSize: this.searchform.pageSize,
        currPage: this.searchform.currPage
      });
      console.log(currPage);
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize;
      this.search();
    },
    // 载入提示
     open() {
        const h = this.$createElement;

        this.$notify({
          title: '页面提示',
          message: h('i','数据量较大，请输入搜索条件进行筛选')
        });
      },
    //导出表格事件
    handleDownload() {
      if (
         this.searchform.outtimelist ||
        this.searchform.dealerName ||
        this.searchform.dealerCode ||
        this.searchform.freightBillCode ||
        this.searchform.outBillCode ||
        this.searchform.fromWarehouseCode ||
        this.searchform.batchno ||
        this.searchform.productCode
      ) {
        this.downloadLoading = true;
        const obj = {
          currPage: 1,
          pageSize: this.total_count,
        soutBillTime: this.searchform.outtimelist==null ? null:this.searchform.outtimelist[0],
        eoutBillTime: this.searchform.outtimelist==null ? null:this.searchform.outtimelist[1],
          dealerName: this.searchform.dealerName,
          dealerCode: this.searchform.dealerCode,
          freightBillCode: this.searchform.freightBillCode,
          outBillCode: this.searchform.outBillCode,
          fromWarehouseCode: this.searchform.fromWarehouseCode,
          batchno: this.searchform.batchno,
          productCode: this.searchform.productCode
        };
        orderandworkproducts(obj).then(response => {
          this.tableDataDownload = response.data.list;
          this.packdate(this.tableDataDownload);
          import("@/vendor/Export2Excel").then(excel => {
            const tHeader = [
              "运单号",
              "发运单号",
              "客户编码",
              "客户名称",
              "客户地址",
              "发货仓库编码",
              "发货仓库",
              "发货日期",
              "条码",
              "订单",
              "批次号",
              "工厂",
              "班组",
              "产线",
              "生产时间",
              "产品编码",
              "产品名称",
              "箱规",
              "有效期(天)"
            ];
            const filterVal = [
              "freightBillCode",
              "outBillCode",
              "dealerCode",
              "dealerName",
              "address",
              "fromWarehouseCode",
              "fromWarehouse",
              "outBillTime",
              "qrcode",
              "orderno",
              "batchno",
              "factoryName",
              "workgroupName",
              "worklineName",
              "produceTime",
              "productCode",
              "productName",
              "specs",
              "qualityPeriod"
            ];
            const list = this.tableDataDownload;
            const data = this.formatJson(filterVal, list);
            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: this.filename,
              autoWidth: this.autoWidth,
              bookType: this.bookType
            });
            this.downloadLoading = false;
          });
        }); // hear
      } else {
        this.$message({
          type: "warning",
          message: "请输入搜索条件"
        });
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}
.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.handle-box {
  margin-bottom: 0px;
}
.handle-input {
  width: 160px;
  display: inline-block;
}
.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}
.mr10 {
  margin-right: 10px;
}
#parent {
  text-align: center;
}
</style>